export const useClsUtil_08 = () => {
  // 在 BoYuanHour 组件内部定义一个函数来处理样式逻辑
  const getCls01 = () => {
    // 基础样式
    let classes = "backdrop-blur-10 pl-0 pr-0 flex flex-col justify-center items-start";
    classes += " bg-[var(--app-bg-08)] rounded-10 py-16";

    return classes;
  };
  // 计算类名的函数
  const getCls02 = () => {
    const baseClasses = "flex flex-col justify-start items-center text-center align-top";

    // 使用 if-else 结构，提高可读性
    let paddingClasses = "";

    paddingClasses = "p-[10px_5px]";

    let widthClasses = "min-w-50 first-of-type:ml-8 last-of-type:mr-8";

    return [baseClasses, paddingClasses, widthClasses];
  };

  const getFontSize = (): string => {
    return "text-14";
  };

  const getHeightClass = (): string => {
    return "h-30";
  };
  const getCls03 = ({ index }: any) => {
    return [
      "font-normal flex-[1]",
      `mb-10 ${getFontSize()}`,
      index === 0 ? "color-[var(--app-text-04)]" : "color-[var(--app-text-02)]",
    ];
  };

  const getCls04 = () => {
    const baseClasses = ["flex-[1] center"];

    return [...baseClasses, "mb-10"];
  };

  const getCls05 = () => {
    const baseClasses = ["block"];

    return [...baseClasses, getHeightClass()];
  };
  const getCls06 = () => {
    const baseClasses = ["font-normal color-[var(--app-text-04)]"];

    return [...baseClasses, getFontSize()];
  };
  const getCls07 = () => {
    const baseClasses = "overflow-x-scroll overflow-y-hidden whitespace-nowrap flex justify-start items-center w-full";
    return `${baseClasses} pt-10`;
  };
  const getCls08 = () => {
    return ["flex-[1]", "mb-10"];
  };
  return {
    getCls01,
    getCls02,
    getCls03,
    getCls04,
    getCls05,
    getCls06,
    getCls07,
    getCls08,
  };
};
